export default __webpack_public_path__ + "initiate-icon.svg";